import { Segmented as SegmentedAntd, SegmentedProps } from 'antd';
import classNames from 'classnames';
import { memo } from 'react';

export const Segmented = memo(({ className, ...rest }: SegmentedProps<string | null>) => (
  <SegmentedAntd className={classNames('ctv-segmented', className)} {...rest} />
));

Segmented.displayName = 'Segmented';
